module.exports = __webpack_public_path__ + "static/media/dirgha_pee.e72004e0.ogg";